import React from 'react';
import { useTranslation } from 'react-i18next';
import Omega3SoftgelImage from '../../../assets/omega3/omega3-capsule.webp';

const Omega3EditorOption = ({ isSelected, onChange, priceLabel }) => {
  const { t } = useTranslation();
  return (
    <label className="t-my-3 t-flex t-w-full t-cursor-pointer t-items-start t-gap-3 t-rounded-xl t-border t-border-quiz-teal/30 t-bg-teal-bg t-p-3">
      <img
        src={Omega3SoftgelImage}
        alt=""
        aria-hidden="true"
        className="t-h-10 t-w-10 t-shrink-0 t-object-contain"
      />
      <span className="t-flex-1 t-text-sm t-text-navy">
        <span className="t-block t-font-bold">{t('Omega3_Selection_Title')}</span>
        <span className="t-block t-text-xs">{t('Omega3_Selection_Packaging')}</span>
        <span className="t-mt-1 t-block t-text-xs t-font-semibold">{priceLabel}</span>
      </span>
      <input
        type="checkbox"
        checked={isSelected}
        onChange={(event) => onChange(event.target.checked)}
        className="t-mt-1 t-h-4 t-w-4 t-accent-quiz-teal"
        aria-label={t('Omega3_Selection_Title')}
      />
    </label>
  );
};

export default Omega3EditorOption;
